export const OPEN = 'MODALS/OPEN';

export const open = modal => ({
  type: OPEN,
  payload: {
    modal,
  },
});
